import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from "react-redux";

import DelayButton from '../../common/DelayButton';
import { addToast } from "../../../../actions/index";

function SaveButton({ name, idPlaylist }) {
  const stack = useSelector( state => state.stackAutomix );
  const enableActionsButton = useSelector( state => (state.isConnected) );
  const storePopup = useSelector( state => state.storePopup );
  const storePlaylists = useSelector( state => state.storePlaylists );
  const dispatch = useDispatch();
  const isReady = !!((Array.isArray(stack)) ? stack.find( x => x.idPlaylist === idPlaylist ) : ((stack.idPlaylist === idPlaylist) ? stack : null));

  const directCopy = () => {
    if (enableActionsButton) {
      const selectStack = (Array.isArray(stack)) ? stack.find( x => x.idPlaylist === idPlaylist ) : ((stack.idPlaylist === idPlaylist) ? stack : null)
      if (selectStack) {
        let tracks = selectStack.tracks.filter(x => (x.length_s));
        const previews = tracks.filter( x => x.is_available_for_streaming === false );
        const selection = tracks.filter( x => x.is_available_for_streaming === true );
        storePlaylists.new(name, selection, {}, null);
        dispatch(addToast({ content: <span>Playlist '{name}' saved.</span>, typeClass: 'success', iconStyle: { padding: 16, marginRight: 16 } }));
        if (previews.length > 0) {
          dispatch(addToast({ content: <span>{previews.length} track(s) not added to '{name}'. Download only, full-track streaming is unavailable.</span>, typeClass: 'warning', iconStyle: { padding: '32px 16px', marginRight: 16 } }));
        }
      }
    } else {
      storePopup.playlist('.playlist-button-save');
    }
  };

  return (
    <DelayButton label={'Save playlist'} 
      classNameEnable={`playlist-button-save listv2 ${!isReady && 'disable'} `}
      classNameDisable={`playlist-button-save listv2 disable`} 
      onClick={directCopy} 
    />
  )
}

SaveButton.propTypes = {
  idPlaylist: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired
}

export default SaveButton;
